




















import Vue, { PropType } from 'vue';

import { DynamicDocumentItem, DynamicDocumentItemData, ValidationRule } from '@/types';
import { isItemRequired } from '@/utilities';
import documentCtxMixin from '../document-ctx';

export default documentCtxMixin.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    data: Object as PropType<DynamicDocumentItemData>,
    documentData: Array as PropType<DynamicDocumentItemData[]>,
  },

  computed: {
    isRequired(): boolean {
      return isItemRequired(this.item, this.documentData ?? [this.data]);
    },

    rules(): ValidationRule[] {
      return [
        (val: string) => !this.isRequired || !!val || this.$t('validation.general.required'),
        (val: string) =>
          this.item.type !== 'EMAIL' || /.+@.+/.test(val) || this.$t('validation.email.valid'),
      ];
    },

    itemType(): string {
      switch (this.item.type) {
        case 'VALUE':
          return 'text';
        case 'EMAIL':
          return 'email';
        case 'NUMBER':
          return 'number';
        default:
          return 'text';
      }
    },
  },

  methods: {
    scrollTo() {
      const input: Vue = this.$refs.input as Vue;

      setTimeout(() => this.$scrollTo(input.$el, 100, { offset: -150 }), 100);
    },
  },
});
